/**
 =========================================================
 * Material Dashboard 2 PRO React - v2.1.0
 =========================================================

 * Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
 * Copyright 2022 Creative Tim (https://www.creative-tim.com)

 Coded by www.creative-tim.com

 =========================================================

 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
 */

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";

// Material Dashboard 2 PRO React examples
import PageLayout from "examples/LayoutContainers/PageLayout";

function CoverLayout({ coverHeight = "50vh", image = "", children }) {
    const isVideo =
        typeof image === "string" &&
        (image.endsWith(".mp4") ||
            image.endsWith(".m4v") ||
            image.endsWith(".webm") ||
            image.includes(".mp4") ||
            image.includes(".m4v") ||
            image.includes(".webm"));

    return (
        <PageLayout background="white">
            <MDBox
                sx={{
                    position: "relative",
                    width: "100%",
                    minHeight: "100vh",
                    overflow: "hidden",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    px: 2,
                    py: 4,
                }}
            >
                <MDBox
                    sx={{
                        position: "absolute",
                        inset: 0,
                        width: "100%",
                        height: coverHeight || "100vh",
                        zIndex: 0,
                    }}
                >
                    {isVideo ? (
                        <video
                            autoPlay
                            muted
                            loop
                            playsInline
                            style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "cover",
                            }}
                        >
                            <source src={image} type="video/mp4" />
                            Your browser does not support the video tag.
                        </video>
                    ) : (
                        <MDBox
                            sx={{
                                width: "100%",
                                height: "100%",
                                backgroundImage: `url(${image})`,
                                backgroundSize: "cover",
                                backgroundPosition: "center",
                                backgroundRepeat: "no-repeat",
                            }}
                        />
                    )}
                </MDBox>

                <MDBox
                    sx={{
                        position: "absolute",
                        inset: 0,
                        zIndex: 1,
                        background:
                            "linear-gradient(135deg, rgba(0,0,0,0.45) 0%, rgba(0,0,0,0.25) 100%)",
                    }}
                />

                <MDBox
                    sx={{
                        position: "relative",
                        zIndex: 2,
                        width: "100%",
                        minHeight: "100vh",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexDirection: "column",
                    }}
                >
                    {children}
                </MDBox>
            </MDBox>
        </PageLayout>
    );
}

// Typechecking props for the CoverLayout
CoverLayout.propTypes = {
    coverHeight: PropTypes.string,
    image: PropTypes.string,
    children: PropTypes.node.isRequired,
};

export default CoverLayout;